<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->
    <div class="toolbar" id="kt_toolbar">
      <!--begin::Container-->
      <app-sub-header :title="title" :breadcrumbs="breadcrumbs" :back="false" @updateSelect2="initSelect2"></app-sub-header>
      <!--end::Container-->
    </div>
    <!-- Loader -->
    <div class="container-xxl" v-show="!isReady">
      <Loader />
    </div>
    <!--begin::Post-->
    <div v-show="isReady">
      <div class="post d-flex flex-column-fluid" id="kt_post">
        <div id="kt_content_container" class="container-xxl" style="margin-bottom: 50px!important;">
          <div class="card">
            <div class="card-header flex-wrap border-0 pt-6 pb-0">
              <div class="card-title">
                <h3 class="card-label">{{ $t('breadcrumbs.ecommerce.list') }}
                  <i class="fas fa-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" style="margin-left: 5px;" :title="$t('e-commerce.ecommerce_product')"></i>
                </h3>
              </div>
            </div>
            <div class="card-body">
              <table class="table align-middle table-row-bordered fs-6 gy-3" id="kt_datatable_product"
                     style="margin-top: 13px !important; cursor:pointer">
                <thead>
                <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                  <th class="min-w-100px">{{ $t('category.image') }}</th>
                  <th> {{ $t("product.name") }}</th>
                  <th> {{ $t("product.category") }}</th>
                  <th> {{ $t("product.status") }}</th>
                  <th>{{ $t("actions") }}</th>
                </tr>
                </thead>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="editModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('button.detail') }}</h5>

            <!--begin::Close-->
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
              <!--end::Svg Icon-->
            </div>
            <!--end::Close-->
          </div>

          <div class="modal-body">
            <!--begin:Form-->
            <form id="kt_modal_new_target_form" class="form"  @submit.prevent="updateProductStatusData">
              <div class="d-flex flex-column mb-8 fv-row">
                <!--begin::Label-->
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="">{{$t('review.date')}}</span>
                </label>
                <!--end::Label-->
                <input type="text"  readonly class="form-control form-control-solid" v-model="editForm.created_at" required />
              </div>
              <div class="d-flex flex-column mb-8 fv-row">
                <!--begin::Label-->
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="">{{$t('review.customer')}}</span>
                </label>
                <!--end::Label-->
                <input type="text"  readonly class="form-control form-control-solid" v-model="editForm.customer"  required />
              </div>
              <div class="d-flex flex-column mb-8 fv-row">
                <!--begin::Label-->
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="">{{$t('review.product')}}</span>
                </label>
                <!--end::Label-->
                <input type="text"  readonly  class="form-control form-control-solid" v-model="editForm.product"  required />
              </div>
              <div class="d-flex flex-column mb-8 fv-row">
                <!--begin::Label-->
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="">{{$t('review.product')}}</span>
                </label>
                <!--end::Label-->
                <textarea readonly  class="form-control form-control-solid" v-model="editForm.comment"   rows="8" ></textarea>
              </div>
              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{ $t('review.status') }}</span>
                </label>
                <select
                    class="form-select form-select-solid kt_select2"
                    data-control="select2"
                    name="status"
                    v-model="editForm.status"
                    :data-placeholder="$t('review.status')"
                    data-allow-clear="true">
                  <option></option>
                  <option  v-for="(status, index) in getReviewsStatus" :key="index"
                           :value="status.value">{{ status[locale] }} </option>
                </select>
              </div>

              <div class="modal-footer">
                <button type="submit" id="kt_submit_create_code_promo" class="btn btn-sm btn-primary fw-bolder">
                  <span class="indicator-label">{{ $t('button.save') }}</span>
                  <span class="indicator-progress">{{  $t('loading') }}
                          <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                </button>
                <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>

              </div>
            </form>
            <!--end:Form-->
          </div>


        </div>
      </div>
    </div>

  </div>
</template>

<script setup>

import AppSubHeader from "@/views/E-commerce/Partials/AppSubHeader.vue";
import Loader from "@/components/Loader.vue";
import { BASE_URL, BASE_IMAGE_URL } from "@/services/api";
import {useStore} from "vuex";
import {computed, nextTick, onMounted, reactive, ref, watch} from "vue";
import { useRouter, useRoute } from "vue-router"
import {useHasAbility} from "@/composables/hasAbility";
import Ls from "@/services/ls";
import InputDate from "@/components/InputDate.vue";
import i18n from "@/plugins/i18n";


const router = useRouter()
const store = useStore()
const { can } = useHasAbility()

const locale = computed(() => i18n.global.locale)
const getDatatableLocaleUrl = computed(() => {
  return locale.value === 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json"
})
const getReviewsStatus = computed(() => store.getters['ecommerce/getReviewStatus'])

const title = ref("navigation.e-commerce")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.store.dashboard',
    path: '/admin/dashboard'
  },
  {
    name: 'breadcrumbs.ecommerce.list',
    path: '/admin/promotions'
  }
])

const isReady = ref(false)
const table = ref()
const formDeleteData = ref({
  id: null,
  row: null
})
const formCreateData = ref({
  title: '',
  image: '/assets/media/img_default.png',
  apply: ""
})
const image = ref("")
const processCreating = ref(false)
const editForm = ref({
  id: '',
  customer: '',
  product: '',
  comment: '',
  ceated_at: '',
  status: '',
})
const isLoading = ref(false)



watch(() => locale.value, () => {
  nextTick(() => {
    fetchDatas()
  })
})
onMounted(() => {
  isReady.value = false
  initSelect2()
  store.dispatch('ecommerce/loadReviewStatus')
  store.dispatch('permission/loadPermissions').then(() => {
    fetchDatas()
  })
  isReady.value = true
})

function displayApplyName(value) {
  let apply = getReviewsStatus.value.find(ap => ap.value === value)
  let name=''
  let className=''
  if(apply){
    name = apply[locale.value];
    className = apply.className
  }
  return { name, className }
}

function initSelect2() {
  KTApp.initSelect2()
  $(".kt_select2").select2()

  $(".kt_select2").change((e) => {
    switch (e.target.name) {
      case 'status':
        editForm.value.status = e.target.value
        break;
      default:
        break;
    }
  });

}
function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')

  table.value = $("#kt_datatable_product").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: Ls.get('pageLength') ?? 10,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 1, 'asc']],
    ajax: {
      url: BASE_URL + "/get/products/datatables",
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      }
    },
    columns: [
      { data: "image_url" },
      { data: "name" },
      { data: "category_name" },
      { data: "online" },
      { data: "Actions", responsivePriority: -1 }
    ],

    columnDefs: [
      {
        targets: -5,
        orderable: false,
        className: "dt-center clickable",
        render: (t, a, e, l) => {
          if ((e.image_url != null) && (e.image_url != 'null')) {
            return '<img id="' + e.id + '" src="' + e.image_url + '"  style="width: 50px; height: 50px;" />';
          } else {
            return '<img id="' + e.id + '" src="/assets/img_default.jpg"  style="width: 30px; height: 30px;" />';
          }
        },
      },
      {
        targets: -4,
        render: function (t, a, e, l) {
          return '<span >' + t + "</span>";
        },
      },
      {
        targets: -3,
        orderable: false,
        render: function (t, a, e, l) {
          return '<span >' + t + "</span>";
        },
      },
      {
        targets: -2,
        orderable:false,
        searchable:false,
        render:  function(t, a, e, l){
          let render = ""
          if(t && can('product_update')){
            render += '<span class="form-check form-switch form-check-custom form-check-solid visible btn_change_online" data-id="'+ e.id +'"><label><input type="checkbox" checked id="'+ e.id +'"  class="form-check-input online h-20px w-30px" data-id="'+ e.id +'" /><span></span></label></span>';
          }
          if(!t && can('product_update')){
            render += '<span class="form-check form-switch form-check-custom form-check-solid visible btn_change_online" data-id="'+ e.id +'"><label> <input type="checkbox" data-id="'+ e.id +'"  id="'+ e.id +'" class="form-check-input h-20px w-30px"/><span></span></label></span>';
          }
          return render
        },
      },
      {
        width: "20%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: (t, a, e, l) => {
          let render = ""
          if (can('product_update')) {
            render += '<button type="button" data-row="' + l.row + '" data-id="' + e.id + '" data-name="' + e.name + '" class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto me-5 product_view_btn" >' +
                '<i data-row="' + l.row + '" data-id="' + e.id + '" data-name="' + e.name + '"  class="fa fa-edit"></i>' +
                '</button>'
          }
          return render

        },
      },

    ],
    language: {
      url: getDatatableLocaleUrl.value,
    }
  });

  $(document).on("click", "#kt_datatable_product .btn_change_online", (e) => {
    const id = e.target.getAttribute('data-id');
    const isChecked = e.target.checked;

    submitProductUpdateStatus(id, isChecked);  });

  $(document).on("click", "#kt_datatable_product .edit_btn", (e) => {

    editForm.value = {
      id : e.target.getAttribute('data-id'),
      customer: e.target.getAttribute('data-customer'),
      product: e.target.getAttribute('data-product'),
      comment: e.target.getAttribute('data-comment'),
      created_at: e.target.getAttribute('data-date'),
      status: e.target.getAttribute('data-status')
    }
    nextTick(() =>  initSelect2())
    $('#editModal').modal('toggle')
  });
  $(document).on("click", "#kt_datatable_product .product_view_btn", (e) => {
    router.push({ name: 'settings-items-view', query: { product: e.target.getAttribute('data-id') } })

  });

}

function toggleCreateModal() {
  formCreateData.value = {
    title: '',
    image: '',
    apply: ""
  }
  KTImageInput.init();
  $('#createModal').modal('toggle')
}

async function deleteReview(id) {
  Swal.fire({
    title: i18n.global.t('swal.review_deleting'),
    text: i18n.global.t('swal.text'),
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: i18n.global.t('swal.yes'),
    cancelButtonText: i18n.global.t('swal.no'),
  }).then( async (result) => {
    if (result.value) {
      try {
        await store.dispatch('review/deleteReview', id)
        table.value.ajax.reload()
        window.toastr['success'](i18n.global.t('notification.review.delete_success'))
      }catch (e) {
      }
    }
  });
}

async function submitProductUpdateStatus(id, isChecked) {
  try {
    const isSuccess = await store.dispatch('products/updateProductStatus', { id, isChecked });

    if (isSuccess) {
      if (isChecked) {
        window.toastr['success'](i18n.global.t('notification.product.status_success_true'));
      } else {
        window.toastr['success'](i18n.global.t('notification.product.status_success_false'));
      }
    }
  } catch (e) {
    window.toastr['error'](i18n.global.t('notification.product.update_status_error'));
  }
}
</script>

<style scoped>

</style>